import { app } from '../../../app';
import { Controller } from './sms-user-otp.controller';

app.component('smsUserOtp', {
    templateUrl: require('./sms-user-otp.html'),
    controller: Controller,
});



// WEBPACK FOOTER //
// ./src/portal/states/public/sms-user-otp/sms-user-otp.component.js